<dashboard-dialog-frame [icon]='icon()' header='Select Event Type' [actions]='actions' [dialogRef]='dialogRef'>

	<div class="acc-delivery-select-event-type-dialog p-2">
		<readonly-access [readonly]="isReadonly()"></readonly-access>

		<p class="mb-3"><b>NOTE:</b> Please add a Google Meet Code to the Accelerator before adding events. This will automatically assign the Accelerator Google Meet Code to the events</p>

		<table style='width:100%' class='pro-table pro-table-no-header pro-table-with-labels pro-table-without-border'>
			<tr>
				<td style="width: 40%;">Event Type</td>
				<td>
					<droplist [items]='eventTypes()' [selectedItem]='' [readonly]="isReadonly()"
						(selectionChange)='onViewDroplistChange($event)' sortBy='customSort'>
					</droplist>
				</td>
			</tr>
		</table>
	</div>

</dashboard-dialog-frame>